import { render, staticRenderFns } from "./NcDescription.vue?vue&type=template&id=6d311b09&"
import script from "./NcDescription.vue?vue&type=script&lang=js&"
export * from "./NcDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports